import { Root as RootSeparator } from "@radix-ui/react-separator";
import type { ComponentPropsWithoutRef, Ref } from "react";
import { cn } from "../lib/utils";

interface SeparatorProps
  extends ComponentPropsWithoutRef<typeof RootSeparator> {
  decorative?: boolean;
  orientation?: "horizontal" | "vertical";
  thickness?: "regular" | "thick";
}

const Separator = ({
  decorative = true,
  orientation = "horizontal",
  thickness = "regular",
  className,
  ref,
  ...props
}: SeparatorProps & { ref?: Ref<HTMLDivElement> }) => (
  <div className="group relative flex items-center">
    <RootSeparator
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-gray-200 transition-colors",
        // Orientation-specific styles
        orientation === "horizontal"
          ? ["w-full", thickness === "regular" ? "h-[1px]" : "h-0.5"]
          : ["h-full", thickness === "regular" ? "w-[1px]" : "w-0.5"],
        className,
      )}
      {...props}
    />
  </div>
);

Separator.displayName = "Separator";

export { Separator };
